import React from 'react';

const OPTIONS = [
  { value: 'small', labelKey: 'Small grid' },
  { value: 'medium', labelKey: 'Medium grid' },
  { value: 'large', labelKey: 'Large grid' }
];

function GridIcon({ density }) {
  // density: 1 (large), 2 (medium), 3 (small)
  const squares = Array.from({ length: density * density });
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2">
      {squares.map((_, idx) => {
        const row = Math.floor(idx / density);
        const col = idx % density;
        const size = 4;
        const gap = 2;
        const total = density * size + (density - 1) * gap;
        const margin = (24 - total) / 2;
        const x = margin + col * (size + gap);
        const y = margin + row * (size + gap);
        return <rect key={idx} x={x} y={y} width={size} height={size} rx="1" />;
      })}
    </svg>
  );
}

export default function GridSizeToggle({ value, onChange, t }) {
  const getIconDensity = (v) => {
    if (v === 'small') return 3;
    if (v === 'large') return 1;
    return 2;
  };

  return (
    <div className="hidden md:inline-flex items-center rounded-md ring-1 ring-inset ring-gray-300 dark:ring-gray-700 overflow-hidden">
      {OPTIONS.map((opt) => {
        const isActive = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            className={[
              "inline-flex h-9 w-9 items-center justify-center text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800",
              isActive ? "bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-gray-100" : "bg-white dark:bg-gray-900"
            ].join(' ')}
            title={t(opt.labelKey)}
            aria-pressed={isActive}
            aria-label={t(opt.labelKey)}
          >
            <GridIcon density={getIconDensity(opt.value)} />
          </button>
        );
      })}
    </div>
  );
}


